
import React, { useState, useCallback, useEffect } from 'react';
import { getUnitsDropDown } from '../../../utils/apicall/commonApi';
import { authService } from '../../../utils/authServices';
import { processError } from '../../../utils/error/errorUtils';
import { ApiError, handleError } from '../../../utils/error/error';
import NotFound from '../../common/404';
import GeneralErrorPage from '../../common/general-error';
import { addUser } from '../../../utils/apicall/usersApi';


const UserAdd: React.FC  = ( ) => {
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [errors, setErrors] = useState<{ [key: string]: string[] }>({});
  const [successMessage, setSuccessMessage] = useState<string | null>(null);
    const [formData, setFormData] = useState({
      name: '',
      email: '',
      password: '',
      role: '',
      accessible_units: [] as string[], // Store selected unit IDs here
    });
    const [units, setUnits] = useState<{ id: number; title: string }[]>([]); // State for loading units

    
   
      const loadUnits = useCallback(async () => {
        try {
          const response = await getUnitsDropDown();
          if (response) {
            setUnits(response);
          }
        } catch (error) {
          console.error('An error occurred while fetching data.', error);
        }
      }, []);
      useEffect(() => {
     
        loadUnits();
        authService.getTokenExpiration();
      }, [loadUnits]);
    
      const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value, type } = e.target;
    
        if (type === 'checkbox' && e.target instanceof HTMLInputElement) {
          const checked = e.target.checked;
          setFormData((prevData) => ({
            ...prevData,
            accessible_units: checked
              ? [...prevData.accessible_units, value]
              : prevData.accessible_units.filter((runit) => runit !== value),
          }));
        } else {
          setFormData((prevData) => ({
            ...prevData,
            [name]: value,
          }));
        }
      };
    //ADD USER
      const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        console.log(formData);
        e.preventDefault();
          if (formData) {
            try {
             
              const response = await addUser(formData); 
            
              setSuccessMessage('Προστέθηκε με επιτυχία!');
              
               
            
            } catch (error) {
              handleError(error);
              processError(error, setErrors, setErrorMessage, setSuccessMessage);
                      if (error instanceof ApiError && error.statusCode === 404) {
                          return <NotFound />;
                      } else {
                          console.error('An unexpected error occurred:', error);
                          return <GeneralErrorPage />;
                      }
            }
          }
      };
    
    
      return (
        <div className="content">
          <section className="ontotita py-5">
            <div className="container mt-4">
              <div className="card p-5">
              <h2 className="h5 mb-2 text-primary">Προσθήκη νέου χρήστη</h2>
           
            <hr />
              <form onSubmit={handleSubmit}>
              {successMessage && (
                            <div className="alert alert-success alert-dismissible fade show" role="alert">
                                <strong></strong> {successMessage}
                                <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="alert"
                                aria-label="Close"
                                ></button>
                            </div>
                            )}
                            {errorMessage && (
                            <div className="alert alert-danger alert-dismissible fade show" role="alert">
                                <strong></strong> {errorMessage}
                                <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="alert"
                                aria-label="Close"
                                ></button>
                            </div>
                            )}

                {/* Full Name */}
                <div className="mb-3">
                  <label htmlFor="name" className="form-label">Ονοματεπώνυμο</label>
                  <div className="input-group">
                    <span className="input-group-text"><i className="bi bi-person"></i></span>
                    <input
                      type="text"
                      className="form-control"
                      id="name"
                      name="name"
                      placeholder="Εισάγετε το ονοματεπώνυμο"
                      required
                      value={formData.name}
                      onChange={handleChange}
                    />
                  </div>
                </div>
    
                {/* Email */}
                <div className="mb-3">
                  <label htmlFor="email" className="form-label">Email</label>
                  <div className="input-group">
                    <span className="input-group-text"><i className="bi bi-envelope"></i></span>
                    <input
                      type="email"
                      className="form-control"
                      id="email"
                      name="email"
                      placeholder="Εισάγετε το email"
                      required
                      value={formData.email}
                      onChange={handleChange}
                    />
                  </div>
                </div>
    
                {/* Password */}
                <div className="mb-3">
                  <label htmlFor="password" className="form-label">Κωδικός</label>
                  <div className="input-group">
                    <span className="input-group-text"><i className="bi bi-lock"></i></span>
                    <input
                      type="password"
                      className="form-control"
                      id="password"
                      name="password"
                      placeholder="Εισάγετε τον κωδικό"
                      required
                      value={formData.password}
                      onChange={handleChange}
                    />
                  </div>
                </div>
    
                {/* Role Selection */}
                <div className="mb-3">
                  <label htmlFor="role" className="form-label">Επιλογή Ρόλου</label>
                  <div className="input-group">
                    <span className="input-group-text"><i className="bi bi-person-badge"></i></span>
                    <select
                      className="form-select"
                      id="role"
                      name="role"
                      required
                      value={formData.role}
                      onChange={handleChange}
                    >
                      <option value="" disabled>Επιλέξτε ρόλο</option>
                      <option value="admin">Admin</option>
                      <option value="unitadmin">Unit Admin</option>
                    </select>
                  </div>
                </div>
    
                {/* Regional Units Checkboxes */}
                <div className="mb-3">
                  <label className="form-label">Επιλογή Περιφερειακών Ενοτήτων</label>
                  <div className="d-flex flex-wrap">
                    {units.map((unit) => (
                      <div key={unit.id} className="form-check me-3">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id={`accessible_units-${unit.id}`}
                          name="accessible_units"
                          value={unit.id.toString()}
                          checked={formData.accessible_units.includes(unit.id.toString())}
                          onChange={handleChange}
                        />
                        <label className="form-check-label" htmlFor={`accessible_units-${unit.id}`}>
                          {unit.title}
                        </label>
                      </div>
                    ))}
                  </div>
                </div>
    
                {/* Submit Button */}
                <div className="text-end mt-4">
                  <button type="submit" className="btn btn-primary">
                    <i className="bi bi-save me-1"></i> Εισαγωγή Χρήστη
                  </button>
                </div>
              </form>
              </div>
          </div>
        </section>
      </div>
      );
    };
    
    export default UserAdd;